import {
    errorFetchingRequestState,
    getInitialRequestState,
    startFetchingRequestState,
    successFetchingRequestState
} from "../../models/common/RequestState";
import {InvoiceItemFetchState} from "./OutInvoiceProjectTaskTimeItemsReducer";
import {Nullable} from "../../models/common/Nullable";
import {OutgoingInvoiceProjectTaskItem} from "../../models/accounting/OutgoingInvoiceProjectTaskItem";

import {
    FETCH_OUT_INVOICES_PROJECT_TASK_FLAT_ITEM,
    FETCH_OUT_INVOICES_PROJECT_TASK_FLAT_ITEM_ERROR, FETCH_OUT_INVOICES_PROJECT_TASK_FLAT_ITEM_SUCCESS,
    OutgoingInvoiceProjectTaskFlatItemViewActionTypes
} from "../../actions/account-book/OutInvoiceProjectTaskFlatItemActions";


export interface OutgoingInvoiceProjectTaskFlatrateItemsState {
    flatRateItems: InvoiceItemFetchState<Nullable<OutgoingInvoiceProjectTaskItem[]>>
}

const initialState: OutgoingInvoiceProjectTaskFlatrateItemsState = {
    flatRateItems: {
        request: getInitialRequestState(),
            entries:null
    }
}

export function OutgoingInvoiceProjectTaskFlatrateItemsReducer(
    state: OutgoingInvoiceProjectTaskFlatrateItemsState = initialState,
    action:OutgoingInvoiceProjectTaskFlatItemViewActionTypes
) {

    switch (action.type) {
        case FETCH_OUT_INVOICES_PROJECT_TASK_FLAT_ITEM:
            return {
                ...state,
                flatRateItems: {
                    entries: null,
                    request: startFetchingRequestState()
                }
            };
        case FETCH_OUT_INVOICES_PROJECT_TASK_FLAT_ITEM_SUCCESS:
            return {
                ...state,
                flatRateItems: {
                    entries: action.payload,
                    request: successFetchingRequestState()
                }
            };
        case FETCH_OUT_INVOICES_PROJECT_TASK_FLAT_ITEM_ERROR:
            return {
                ...state,
                flatRateItems: {
                    ...state.flatRateItems,
                    request: errorFetchingRequestState( action.error )
                }
            };
        default:
            return state;
    }
}